export const ORDER_RING_OPTIONS = {
  CONTINUOUS: 'continuous',
  SINGLE: 'single',
  STOP: 'stop',
  NON_STOP: 'non stop',
};
